"use client";
import c from "styled-components";
import e from "react";
import "./index.es9.js";
import "./index.es10.js";
import "./index.es11.js";
import "./index.es12.js";
import "./index.es13.js";
import "./index.es14.js";
import "./index.es15.js";
import "./index.es16.js";
import "./index.es17.js";
import d from "./index.es62.js";
import "./index.es27.js";
import "./index.es28.js";
import "./index.es19.js";
import "./index.es20.js";
import "./index.es21.js";
import "./index.es22.js";
import "./index.es23.js";
import "./index.es24.js";
import "./index.es25.js";
import "./index.es26.js";
import "./index.es29.js";
import "./index.es30.js";
import "./index.es31.js";
import "./index.es32.js";
import "./index.es44.js";
import "./index.es46.js";
import "./index.es47.js";
import "./index.es48.js";
import "./index.es49.js";
import "./index.es50.js";
import "./index.es51.js";
import E from "./index.es77.js";
import { currentQueryParamsString as f, GeoTypeNames as p } from "./index.es4.js";
import v from "./index.es78.js";
import u, { spreadKeysClass as s } from "./index.es79.js";
import h from "./index.es80.js";
import $ from "./index.es81.js";
const w = c.div`
  .bl-info-box {
    display: none;
  }

  ${d.mediaQueries["bl-handset-down"]} {
    .bl-info-box {
      display: block;
      margin: 0.5rem 0;
    }
    .bl-info-box__header-content {
      font-weight: normal;
    }
  }
`, y = c.div`
  ${d.mediaQueries["bl-handset-down"]} {
    overflow-x: auto;
  }
`, ne = ({
  indicatorGroup: t,
  primaryRegion: r,
  comparisonRegions: o,
  indicatorValues: b,
  compareScope: m,
  categories: l,
  slug: i
}) => r ? /* @__PURE__ */ e.createElement(w, null, /* @__PURE__ */ e.createElement(u, null, /* @__PURE__ */ e.createElement("div", { className: "bl-m-r-4 bl-m-b-2" }, /* @__PURE__ */ e.createElement("p", { className: "bl-p-b-4" }, t?.description), /* @__PURE__ */ e.createElement(
  "a",
  {
    href: `/${process.env.NEXT_PUBLIC_STATS_BASE_URL}/monitor/${i}/${t?.slug}${f()}`,
    className: "bl-link"
  },
  "Gå til detaljert oversikt"
)), /* @__PURE__ */ e.createElement("div", null, /* @__PURE__ */ e.createElement(
  "div",
  {
    className: `bl-border--large bl-border--sand-3 ${s}`
  },
  /* @__PURE__ */ e.createElement(
    v,
    {
      id: `${s}-${t?.id}`,
      scopeName: p[m]
    }
  )
)), /* @__PURE__ */ e.createElement(E, { header: "Sveip mot venstre for å se hele tabellen" })), /* @__PURE__ */ e.createElement(y, null, /* @__PURE__ */ e.createElement(h, { className: "bl-size-6 bl-m-t-4" }, /* @__PURE__ */ e.createElement("caption", null, t?.title), /* @__PURE__ */ e.createElement("thead", null, /* @__PURE__ */ e.createElement("tr", null, /* @__PURE__ */ e.createElement("th", { scope: "col" }, "Indikator"), o?.length > 0 && /* @__PURE__ */ e.createElement("th", { scope: "col" }, "Sted"), /* @__PURE__ */ e.createElement("th", { scope: "col" }, "Verdi for sted"), /* @__PURE__ */ e.createElement("th", { scope: "col" }, `Verdi for ${p[m]}`), /* @__PURE__ */ e.createElement("th", { scope: "col" }, "Grafisk visning"))), /* @__PURE__ */ e.createElement("tbody", null, t?.indicators?.map(
  (n) => [r, ...o].map((a) => /* @__PURE__ */ e.createElement(
    $,
    {
      key: `row-indicator-${n.id}-region-${a?.regionCode}-${l?.join("-")}`,
      region: a,
      indicator: n,
      compareScope: m,
      primaryRegion: r,
      comparisonRegions: o,
      indicatorValues: b,
      categories: l,
      slug: i,
      group: t
    }
  ))
).flat())))) : /* @__PURE__ */ e.createElement(e.Fragment, null);
export {
  ne as default
};
//# sourceMappingURL=index.es58.js.map
